import MODES from './modes';

export default {
  [MODES.desktop]: { width: 1280, height: 720 },
  [MODES.tablet]: { width: 768, height: 1024 },
  [MODES.mobile]: { width: 375, height: 812 },
};
